import { BasicScenario, CssRenderWrapper, BasicCriteria } from '@wizeoo/akm-message-lib';

import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';

/**
 * Commande REST de recherche des rendus css
 */
export class FindCssRenderCommand extends WizCommand<CssRenderWrapper> {

  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }


  /** retourne un wrapper pre-alimenté */
  public cssRenderWrapper(): CssRenderWrapper {
    const wrapper: CssRenderWrapper = new CssRenderWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.scenario = new BasicScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    wrapper.criteria = new BasicCriteria();
    return wrapper;
  }

  /** configuration du chargement des formats à partir d'un domaine et d'une bu & vision */
  public find(domain: string, bu: string): FindCssRenderCommand {
    const wrapper: CssRenderWrapper = this.cssRenderWrapper();
    wrapper.criteria.domain = domain;
    wrapper.criteria.businessUnitCode = bu;
    this.configureRemote(ExternalAPI.CSS_API, wrapper);
    return this;
  }

  wizResult() {
    super.wizResult();
    if (this.result?.entities) {
      this.model.styleEngine.feedCssRenders(this.result.entities);
    }

  }
}
